import React from 'react';
import { handleUrlOnClick } from '@gettactic/helpers/src/event-handlers/handleUrlOnClick';
import { useRouter } from 'next/router';

export interface LinkProps
  extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  href: string;
}

export const Link: React.FC<LinkProps> = React.forwardRef<
  HTMLAnchorElement,
  LinkProps
>(
  (
    { href, target, rel = 'noopener noreferrer', children, onClick, ...props },
    ref
  ) => {
    const router = useRouter();

    const handleRouterPush = (event: React.MouseEvent) => {
      event.stopPropagation();
      event.preventDefault();
      router.push(href);
    };

    return (
      <a
        href={href}
        target={target}
        rel={rel}
        onClick={handleUrlOnClick((onClick as never) || handleRouterPush)}
        ref={ref}
        {...props}
      >
        {children}
      </a>
    );
  }
);

Link.displayName = 'Link';
